import ExtensionService from 'live/services/extension'
import i18n from 'live/services/i18n'
import Form from './Page/Form';
import { PLUGIN_ALIAS, PLUGIN_TYPE } from './constant';
import { HelpPage } from './Page/Help';


ExtensionService.register({
    name: PLUGIN_ALIAS,
    type: PLUGIN_TYPE,
    origin: PLUGIN_ALIAS,
    roles: [],
    icon: '/content/plugin-entities/entities.png',
    ui: {
        form: Form,
        view: null,
        //TODO:PAGE HELP
        // custom: {
        //     'help': {
        //         label: i18n('Help'),
        //         component: HelpPage
        //     }
        // }
    }
});
